export const aboutNumbers: { title: string, content: string }[] = [
  { title: '9', content: 'about.principles' },
  { title: '200+', content: 'about.signatories' },
  { title: '100+', content: 'about.partners' },
];

export const list = ['about.list-item-1', 'about.list-item-2', 'about.list-item-3', 'about.list-item-4', 'about.list-item-5'];
